export default "__VITE_ASSET__BozAETmA__"